module.exports = {
  read: (uid) => global.socket.request("filesystem.readFolder", {uid})
}
